import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";
import React from "react";
import type { Color } from "@msuite/utils/colors";

/** Props Interface */
export interface StatusIndicatorProps extends VariantProps<typeof statusIndicator> {
	withPing?: boolean;
	className?: string;
	color: Color | undefined;
}

export function StatusIndicator({
	color = "gray",
	size,
	withPing = false,
	className,
}: StatusIndicatorProps) {
	/** Cva */
	const classes = statusIndicator({ size });

	/** Render */
	return (
		<div
			className={clsx("status-indicator", classes, className)}
			style={{
				backgroundColor: `var(--color-${color}-500)`,
			}}
		>
			{withPing && (
				<React.Fragment>
					<div
						className={clsx(classes, "animate-ping absolute inset-0")}
						style={{
							backgroundColor: `var(--color-${color}-500)`,
						}}
					/>
				</React.Fragment>
			)}
		</div>
	);
}

const statusIndicator = cva(["rounded-full relative shrink-0 aspect-square"], {
	variants: {
		size: {
			sm: ["w-1.5 h-1.5"],
			md: ["w-2 h-2"],
			lg: ["w-3.5 h-3.5"],
		},
	},
	defaultVariants: {
		size: "md",
	},
});
